import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
import GeneratePayment from "../subComponent/GenratePayment";

const PaymentGenerator = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        }
    }, []);


    return (
        <Box>
            <AdminHeaderComp />
            <Box sx={{
                display: "flex", flexDirection: { xs: "column", md: "row" }, 
                justifyContent: "space-evenly", gap: "1.5rem", alignItems: { xs: "center", md: "start" },
                backgroundColor: "#0f172a", p: 2
            }}>
                <GeneratePayment />
            </Box>
        </Box>
    )
}
export default PaymentGenerator;